export const validateSeekerStatus = (
  latestRegistrations: any[],
  programRegistrationId?: number,
): boolean => {
  const INVALID_SEEKER_STATUSES = ["denied", "cancelled", "archived"];

  if (!latestRegistrations || latestRegistrations.length === 0) {
    return false;
  }

  const registration = latestRegistrations.find(
    (reg) => reg.programRegistrationId === programRegistrationId,
  );

  if (!registration) {
    return false;
  }

  // Check if the seeker status is not in invalid statuses
  if (
    registration.registerStatus &&
    !INVALID_SEEKER_STATUSES.includes(
      registration.registerStatus?.toLowerCase(),
    )
  ) {
    return true;
  }
};
